export const basicsetupDetailsData = [
    {
        title: 'Customize Branding',
        content: "Upload images, add descriptions, customize your community theme, and make your community truly your own.", 
    },
];
